<template>
  <div class="wrapper">
    <NavBar />
    <SideBar />
    <div class="content-wrapper">
      <router-view></router-view>
    </div>
    <Footer />
    <aside class="control-sidebar control-sidebar-dark"></aside>
  </div>
</template>

<script>
// @ is an alias to /src
import SideBar from "@/components/organisms/SideBar.vue";
import NavBar from "@/components/organisms/NavBar.vue";
import Footer from "@/components/organisms/Footer.vue";

export default {
  name: "DashboardLayout",

  components: {
    SideBar,
    NavBar,
    Footer,
  },
};
</script>
